/**
 * Created by Anti Asko on 3/7/2015.
 */
import {PhoneNumberUtil, PhoneNumberFormat} from 'libphonenumber';
let callingcode = PhoneNumberUtil.getInstance();
callingcode.defaultCountryCode = "US";
callingcode.FORMAT = PhoneNumberFormat;

function defaultCountryCode() {
    return $.ajaxDefaultQ({
        url: '/CampaignCloud/UserInfo',
        type: 'GET'
    });
}

callingcode.init = async function () {
    const cachedCC = self.sessionStorage ? self.sessionStorage.getItem("defaultCountryCode") : self.defaultCountryCode;
    if (cachedCC) {
        callingcode.defaultCountryCode = cachedCC;
        return cachedCC;
    } else {
        try {
            const result = await defaultCountryCode();
            const validatedResult = result.countryCode ? result.countryCode.toString() : "GR";
            window.sessionStorage.setItem("defaultCountryCode", validatedResult);
            callingcode.defaultCountryCode = validatedResult; //admin user
            console.info('The default Country code is: ' + callingcode.defaultCountryCode);
            return result;
        } catch (e) {
            console.error(e);
        }
        return null;
    }
};

export default callingcode;